// extracted by mini-css-extract-plugin
export var root = "_zz-0";
export var scroll = "_zz-1";
export var thumb = "_zz-3";
export var track = "_zz-2";